import { withTheme } from '../ThemeProvider/withTheme';
import { StyledRadioGroup } from './style';
import { RadioGroupProps } from './types';

const RadioButtonComponent: React.FC<RadioGroupProps> = ({ options, name, disabled, ...props }) => (
  <StyledRadioGroup name={name} disabled={disabled} options={options} {...props} />
);

export const RadioButton = withTheme(RadioButtonComponent);
